<template>
  <div
    v-click-outside="clickOutside"
    class="filters-wrapper d-lg-block"
    :class="{ open: showFilters, 'd-none': !isMobile }"
  >
    <div v-show="showFilters" class="overlay" @click="closeFilters"></div>
    <div class="sidebar-wrapper" :class="{ open: showFilters }" :style="styles">
      <div class="sidebar-fixed" :class="{ design: isDesignActive }">
        <div class="sidebar-filter">
          <div class="collapse-title">
            <div class="d-md-none d-flex justify-content-end w-100">
              <button
                class="btn"
                :aria-label="$t('main.searchResult.searchHeader.hideFiltersHeader')"
                @click="closeFilters"
              >
                <Icon icon="bootstrap-x" />
              </button>
            </div>
            <div class="align-items-center d-flex pt-md-2 w-100">
              <label v-b-toggle.collapse-0 for="Image type" class="title d-flex align-items-center">
                {{ $t('main.header.tags.experience') }}
                <Icon icon="bootstrap-caret-up-fill" class="when-open" :width="9" :height="9" />
                <Icon icon="bootstrap-caret-down-fill" class="when-closed" :width="9" :height="9" />
              </label>
              <button
                class="btn d-none d-md-block px-0"
                :aria-label="$t('main.searchResult.searchHeader.hideFiltersHeader')"
                @click="closeFilters"
              >
                <Icon
                  icon="bootstrap-chevron-left"
                  class="vx-btn-chevron exp-bg-hover"
                  :width="12"
                  :height="12"
                />
              </button>
            </div>
          </div>
          <b-collapse id="collapse-0" visible>
            <UIButton
              v-bind="{ ...commonButtonProps, ...merchButtonProps }"
              :extra-data="{ event: '' }"
              :to="
                $urlBuilder('search', {
                  path: getDimensionByName(getDimensionAll, getMerch).path,
                  keyword: actualSearch
                })
              "
              @click="setExperience(getMerch)"
            >
              {{ $t('main.header.tags.forMerch') }}
            </UIButton>
            <UIButton
              v-bind="{ ...commonButtonProps, ...designButtonProps }"
              :extra-data="{ event: '' }"
              :to="
                $urlBuilder('search', {
                  path: getDimensionByName(getDimensionAll, getDesign).path,
                  keyword: actualSearch
                })
              "
              @click="setExperience(getDesign)"
            >
              {{ $t('main.header.tags.design') }}
            </UIButton>
            <div v-if="noExperienceSelected" class="experience-container">
              <div class="close-info d-flex justify-content-end w-100">
                <button
                  class="btn pr-0"
                  :aria-label="$t('main.searchResult.searchHeader.closeExperienceTooltip')"
                  @click="removeChooseExperience"
                >
                  <Icon icon="bootstrap-x" />
                </button>
              </div>
              <p class="info">{{ $t('main.searchResult.searchHeader.betterExperience') }}</p>
              <UIButton
                :to="$trailingSlash(localePath('new-vexels'))"
                shape="outline-transparent neutral-gray"
                size="small-medium"
              >
                {{ $t('main.searchResult.searchHeader.learnMore') }}
              </UIButton>
            </div>
          </b-collapse>
          <div class="collapse-title">
            <label v-b-toggle.collapse-1 for="Image type" class="title d-flex align-items-center">
              {{ $t('main.header.tags.content') }}
              <Icon icon="bootstrap-caret-up-fill" class="when-open" :width="9" :height="9" />
              <Icon icon="bootstrap-caret-down-fill" class="when-closed" :width="9" :height="9" />
            </label>
          </div>
          <b-collapse id="collapse-1" visible>
            <UIButton
              v-for="(item, index) in orderedExperience"
              :key="index"
              event=""
              :style="{ color: 'inherit' }"
              :to="
                !resultsDimension(item.path)
                  ? ''
                  : $urlBuilder('search', { path: item.path, keyword: actualSearch })
              "
              v-bind="{
                ...commonButtonProps,
                ...contentProps(item.name)
              }"
              :enabled="resultsDimension(item.path)"
              @click.native="clickContentDimension(item.path)"
            >
              {{ item.name }}
            </UIButton>
          </b-collapse>

          <div v-if="nichesResult.length" class="collapse-title mt-2">
            <label
              v-b-toggle.collapse-niches
              for="Image type"
              class="title d-flex align-items-center"
            >
              {{ $t(`main.header.tags.${isDesignActive ? 'topics' : 'niches'}`) }}
              <Icon icon="bootstrap-caret-up-fill" class="when-open" :width="9" :height="9" />
              <Icon icon="bootstrap-caret-down-fill" class="when-closed" :width="9" :height="9" />
            </label>
          </div>
          <b-collapse v-if="nichesResult.length" id="collapse-niches" visible class="row">
            <div v-for="item in nichesResult" :key="item.id" class="col-12 col-md-6 my-2">
              <nuxt-link
                class="exp-font"
                :to="$urlBuilder(isDesignActive ? 'topics' : 'niches', { slug: item.slug })"
              >
                <button
                  type="button"
                  class="vx-btn small w-100 text-center d-block niche-block"
                  :style="`--bg-image: url('${item.thumbnail}')`"
                >
                  {{ item.name }}
                </button>
              </nuxt-link>
            </div>
          </b-collapse>

          <div v-if="hasSideBarRecommendations" class="collapse-title mt-2">
            <label v-b-toggle.collapse-3 for="Image type" class="title d-flex align-items-center">
              {{ $t('main.header.tags.alsoFromVexels') }}
              <Icon icon="bootstrap-caret-up-fill" class="when-open" :width="9" :height="9" />
              <Icon icon="bootstrap-caret-down-fill" class="when-closed" :width="9" :height="9" />
            </label>
          </div>
          <b-collapse v-if="hasSideBarRecommendations" id="collapse-3" visible>
            <a v-for="rec in sideBarRecommendations" :key="rec.id" :href="rec.link" target="_blank">
              <div class="image-section" :style="'background-image: url(' + rec.urlImage + ');'">
                <h5>{{ rec.text }}</h5>
              </div>
            </a>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from 'UI/Icon';
import { mapState, mapGetters } from 'vuex';
import UIButton from 'UI/Button';

export default {
  components: {
    Icon,
    UIButton
  },
  data() {
    return {
      scrolled: 0,
      width: 0,
      top: 70,
      hideChooseExperience: false,
      isMobile: false
    };
  },
  computed: {
    ...mapState('searchBar', ['actualSearch', 'hasSuggestionSelected', 'elementSelected']),
    ...mapState('search', ['showFilters']),
    ...mapGetters('search', ['nichesResult', 'getTotalResultsDimensions']),
    ...mapGetters('recommendations', ['sideBarRecommendations']),
    ...mapGetters('dimensions', [
      'getFilterDimensionsByExperience',
      'getDimensionAll',
      'getActualDimensionName',
      'getDimensionByName'
    ]),
    ...mapGetters('experience', [
      'getExperience',
      'isDesignActive',
      'isMerchActive',
      'getDesign',
      'getMerch'
    ]),
    orderedExperience() {
      return this.getFilterDimensionsByExperience(this.getExperience).sort((dim1, dim2) =>
        this.resultsDimension(dim1.path) === this.resultsDimension(dim2.path)
          ? 0
          : !this.resultsDimension(dim1.path)
          ? 1
          : -1
      );
    },
    noExperienceSelected() {
      return !this.hideChooseExperience;
    },
    commonButtonProps() {
      return {
        class: 'mb-2 mr-2 d-inline-flex',
        size: 'small-medium'
      };
    },
    merchButtonProps() {
      return !this.isMerchActive
        ? {
            color: 'white',
            text: 'gray',
            hover: 'soft-gray',
            shape: 'outline'
          }
        : {};
    },
    designButtonProps() {
      return !this.isDesignActive
        ? {
            color: 'white',
            text: 'gray',
            hover: 'soft-gray',
            shape: 'outline'
          }
        : {};
    },
    styles() {
      return `top: ${this.top}px;`;
    },
    hasSideBarRecommendations() {
      return this.sideBarRecommendations?.length;
    }
  },
  mounted() {
    this.handleScroll();
    this.handleResize();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    this.top = document.getElementById('header-container').clientHeight;
    this.hideChooseExperience = this.$cookies.get('vx.hideChooseExperience');
    this.filterDisplayMobileCheck();
    window.addEventListener('resize', this.filterDisplayMobileCheck);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('resize', this.filterDisplayMobileCheck);
  },
  methods: {
    filterDisplayMobileCheck() {
      if (process.client) {
        if (window.innerWidth < 991) {
          this.$store.commit('search/SET_FILTERS_VISIBILITY', false);
          this.isMobile = true;
        }
      }
    },
    removeChooseExperience() {
      this.$cookies.set('vx.hideChooseExperience', true);
      this.hideChooseExperience = this.$cookies.get('vx.hideChooseExperience');
    },
    clickContentDimension(path) {
      if (this.resultsDimension(path)) {
        const url = this.$urlBuilder('search', { path, keyword: this.actualSearch });
        this.$ga.event('All Listings', 'Click Content Buttons', url);
        this.$router.push(url);
      }
    },
    setExperience(exp) {
      const url = this.$urlBuilder('search', {
        path: this.getDimensionByName(this.getDimensionAll, exp).path,
        keyword: this.actualSearch
      });
      this.$ga.event('All Listings', 'Click Experience Buttons', url);
      if (exp != this.getExperience) {
        this.$router.push({
          path: url
        });
      }
    },
    handleScroll() {
      this.scrolled = window.scrollY;
    },
    handleResize() {
      this.width = screen.width;
      this.top = document.getElementById('header-container').clientHeight;
    },
    closeFilters() {
      this.$store.commit('search/TOGGLE_FILTERS_VISIBILITY');
    },
    clickOutside(event) {
      if (
        !event.target.closest('#search-filter') &&
        this.filterDisplayMobileCheck() &&
        window.innerWidth <= 991
      )
        this.$store.commit('search/TOGGLE_FILTERS_VISIBILITY');
    },
    backgroundHover(img, event) {
      event.target.style.backgroundImage = `url(${img})`;
    },
    removeBackgroundHover(event) {
      event.target.style.backgroundImage = '';
    },
    contentProps(item) {
      const props =
        this.getActualDimensionName !== item
          ? {
              color: 'light-gray',
              text: 'gray'
            }
          : {
              color: this.isMerchActive
                ? 'merch-color'
                : this.isDesignActive
                ? 'design-color'
                : 'default-color'
            };
      props['extra-data'] = { event: '' };
      return props;
    },
    resultsDimension(dimPath) {
      return this.getTotalResultsDimensions[dimPath] !== 0;
    }
  }
};
</script>

<style lang="scss" scoped>
#collapse-niches > div:nth-child(odd) {
  @include min-md {
    padding-right: 5px;
  }
}
#collapse-niches > div:nth-child(even) {
  @include min-md {
    padding-left: 5px;
  }
}
#collapse-niches > div button {
  color: #9d9d9d;
  &:hover {
    background-size: cover;
    background-position: center;
    color: #ffffff;
    background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), var(--bg-image);
  }
}
.image-section {
  text-align: center;
  width: 100%;
  height: 150px;
  margin: 10px 0px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  color: #000000;
  background-size: cover;
  cursor: pointer;
  box-shadow: inset 0 0 0 2000px rgba(255, 255, 255, 0.5);
  filter: grayscale(1);
}
.image-section:hover {
  color: #ffffff;
  box-shadow: inset 0 0 0 2000px rgba(134, 134, 134, 0.4);
  filter: grayscale(0);
}
.image-section h5 {
  margin: auto;
  font-weight: 500;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
.title {
  font-weight: 500;
  font-size: 18px;
}
.filters-wrapper {
  position: relative;
  z-index: 0;
  opacity: 0;
  transition-property: opacity;
  transition-duration: 0.5s;
  @include lg {
    z-index: 500;
  }
}
.filters-wrapper.open {
  opacity: 1;
}
.collapse-title {
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
}
.overlay {
  display: none;
}
.sidebar-fixed {
  overflow: auto;
  height: calc(100vh - 80px);
  overflow-x: hidden;
}
.sidebar-wrapper {
  position: sticky;
  width: 305px;
  margin-left: -305px;
  transition: margin-left 0.5s;
  border-right: 1px solid #e6e6e6;
  background: #fff;
  z-index: 500;
  &.open {
    margin-left: 0px;
    .sidebar-fixed::-webkit-scrollbar {
      width: 5px;
    }
    .sidebar-fixed::-webkit-scrollbar-thumb {
      background: #e6e6e6;
      border-radius: 4px;
    }
    @include sm {
      width: 85vw;
    }
  }
  @include lg {
    position: fixed;
    top: 0 !important;
    width: 250px;
    height: 100%;
    margin-left: -250px;
  }
  @include sm {
    width: 100%;
    margin-left: -100%;
  }
}
.sidebar-filter {
  width: 305px;
  background-color: #ffffff;
  position: relative;
  padding: 0px 15px;
  height: 100%;
}
.experience-container {
  .info {
    font-size: 14px;
    color: #535353;
    font-weight: 500;
  }
  .close-info {
    position: absolute;
    top: 0px;
    right: 6px;
  }
  position: relative;
  background: #f2f2f2;
  border: 1px solid #b8b8b8;
  border-radius: 6px;
  margin: 10px 0;
  padding: 20px 40px 20px 20px;
}
.experience-container:after,
.experience-container:before {
  bottom: 100%;
  border: solid transparent;
  content: '';
  height: 0;
  width: 0;
  position: absolute;
  left: 77px;
}
.experience-container:after {
  border-color: rgba(0, 0, 0, 0);
  border-bottom-color: #f2f2f2;
  border-width: 10px;
  margin-left: -10px;
}
.experience-container:before {
  border-color: rgba(161, 103, 45, 0);
  border-bottom-color: #8a8a8a;
  border-width: 11px;
  margin-left: -11px;
}
@media all and (max-width: 992px) {
  .sidebar-filter {
    width: 250px;
  }
}

@media all and (max-width: 576px) {
  .sidebar-filter {
    width: 85vw;
    position: relative;
    padding-top: 0px;
  }
  .sidebar-fixed {
    height: 100vh;
  }
  .overlay {
    display: block;
    opacity: 0.5;
    background: #000;
    width: 100%;
    height: calc(100vh + 80px);
    top: -80px;
    left: 0;
    position: fixed;
    z-index: 400;
  }
}
.vx-btn-chevron {
  border: var(--exp-color) solid 1px;
  border-radius: 100%;
  padding: 3px;
  color: var(--exp-color);
  transition: all 0.2s ease;
}
.vx-btn-chevron:hover {
  border: var(--exp-color) solid 1px;
  color: #fff;
  background-color: var(--exp-color);
}
.vx-btn.selected {
  color: white;
}
</style>
